
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bug-bounty",
      function () {
        return require("private-next-pages/bug-bounty.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bug-bounty"])
      });
    }
  